var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['video-wrapper', 'js-video'],style:(_vm.getStyles)},[_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.videoID,"player-width":_vm.getWidth},on:{"ready":_vm.onReady}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110c6208","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-player/index.vue
// module id = XyvV
// module chunks = 6